import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ "value" ]

  connect() {
    // this.valueTarget.addEventListener("change", () => alert('changed'))
  }

  decrement() {
    this.valueTarget.stepDown()
    this.valueTarget.dispatchEvent(new Event('change'))
  }

  increment() {
    this.valueTarget.stepUp()
    this.valueTarget.dispatchEvent(new Event('change'))
  }
}
